var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0625 23.75C17.3254 23.75 20.7812 20.2942 20.7812 16.0312C20.7812 11.7683 17.3254 8.3125 13.0625 8.3125C8.79955 8.3125 5.34375 11.7683 5.34375 16.0312C5.34375 20.2942 8.79955 23.75 13.0625 23.75Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0693 8.60003C24.131 8.30091 25.2444 8.23277 26.3346 8.4002C27.4248 8.56762 28.4665 8.96673 29.3895 9.57064C30.3125 10.1745 31.0953 10.9692 31.6853 11.9012C32.2753 12.8331 32.6587 13.8806 32.8097 14.9732C32.9608 16.0658 32.8759 17.1781 32.5609 18.2352C32.2459 19.2922 31.708 20.2695 30.9835 21.1011C30.259 21.9328 29.3647 22.5995 28.3608 23.0565C27.3569 23.5134 26.2667 23.7499 25.1637 23.75",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37402 29.3011C3.57953 27.5863 5.17993 26.1868 7.04008 25.2206C8.90024 24.2545 10.9655 23.7501 13.0616 23.75C15.1577 23.7499 17.2231 24.2542 19.0833 25.2202C20.9436 26.1862 22.5441 27.5856 23.7497 29.3003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1631 23.75C27.2594 23.7485 29.3252 24.2521 31.1856 25.2182C33.0459 26.1844 34.6461 27.5846 35.8506 29.3003",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.e15eebf7241defdb41e09860c807c46b.svg";
export { ForwardRef as ReactComponent };